export const loadingWrapperStyles = {
  width: "100wh",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "none",
};
